import { render, staticRenderFns } from "./OrganismCard.vue?vue&type=template&id=5e28dbf6"
import script from "./OrganismCard.vue?vue&type=script&lang=js"
export * from "./OrganismCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports